module.exports = __webpack_public_path__ + "static/media/2020.6.24六月主题党日.48e181c9.jpg";